<template>
  <div class="app-top-nav-customer-service">
    <div class="container">
      <h1 class="fs-3 m-0 p-0">CADY Customer Service</h1>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppTopNavCustomerService'
})
</script>

<style lang="scss" scoped>
.app-top-nav-customer-service {
  background: linear-gradient(90deg, #514c9a, #ad4091);
  color: white;
  border: none;
  padding: 1rem 0;

  &__nav-bar {
    background-color: transparent;
  }
}
</style>
